import { configureStore } from '@reduxjs/toolkit'
import authReducer from './reducers/auth.reducer'
import modelsReducer from './reducers/models.reducer'
import mediaReducer from './reducers/media.reducer'
import toastReducer from './reducers/toast.reducer'
import headerReducer from './reducers/header.reducer'
import supabaseReducer from './reducers/supabase.reducer'
import newsReducer from './reducers/news.reducer'
import themeReducer from './reducers/theme.reducer'
import chatReducer from './reducers/chat.reducer'
import promptReducer from './reducers/prompt.reducer'

const rootReducer = {
  auth: authReducer,
  models: modelsReducer,
  media: mediaReducer,
  toast: toastReducer,
  header: headerReducer,
  supabase: supabaseReducer,
  news: newsReducer,
  theme: themeReducer,
  prompt: promptReducer,
  chat: chatReducer,
}

const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production', // Enable Redux DevTools in development mode
})

export default store
